export default class EnterpriseDmv {
    public id = "";
    public fileName = "";
    public path = "";
    public experience = false;
    public withMusic = false;
}